import dayjs from 'dayjs';
import 'arrive/src/arrive';
import { dateShowLoader } from '../../components/loaders';
import {
  loadDatetimepickerAssets,
  withDatetimepickerLocale,
} from '../../vendors/datepicker/datetimepicker_locale';

export const datetimepickerAssetsReady = loadDatetimepickerAssets();

// Canonical day-granularity picker init. Idempotent and exported so a controller can win
// the init deterministically instead of racing the `arrive` handler — a bare instance falls
// back to the datetime format with a time prompt (TW-2104).
export async function initDatePicker(element) {
  await datetimepickerAssetsReady;
  const $element = $(element);
  if (!$element.data('datetimepicker')) {
    $element.datetimepicker(withDatetimepickerLocale({
      format: 'dd/mm/yyyy',
      autoclose: true,
      todayHighlight: true,
      minView: 2,
      maxView: 2,
      pickerPosition: $element.data().position ? $element.data().position : 'bottom-right',
    }));
  }
  return $element;
}

document.arrive('.page-action-header .date-picking-day', async function(element) {
  await datetimepickerAssetsReady;
  const $element = $(element);
  $element.datetimepicker(withDatetimepickerLocale({
    format: 'yyyy-mm-dd',
    autoclose: true,
    isInline: true,
    todayHighlight: false,
    minView: 2,
    maxView: 3,
    todayBtn: true,
    startView: 'year',
    pickerPosition: 'bottom-right',
    initialDate: dayjs().startOf('day').format('YYYY-MM-DD'),
  }));
  $element.on('changeDate', function(ev) {
    dateShowLoader($element);
    if ($element.attr('data-no-redirect') === undefined) {
      const url = location.origin + location.pathname + '?date=' + dayjs(ev.date).format('YYYY-MM-DD');
      if ($element.parents('turbo-frame')[0]) {
        $element.parents('turbo-frame')[0].src = url;
      } else {
        Turbo.visit(url);
      }
    }
  });
});

document.arrive('.page-action-header .date-picking-month', async function(element) {
  await datetimepickerAssetsReady;
  const $element = $(element);
  $element.datetimepicker(withDatetimepickerLocale({
    format: 'yyyy-mm-dd',
    autoclose: true,
    isInline: true,
    todayHighlight: false,
    minView: 3,
    maxView: 3,
    todayBtn: true,
    startView: 'year',
    pickerPosition: 'bottom-right',
    initialDate: dayjs().startOf('day').format('YYYY-MM-DD'),
  }));
  $element.on('changeDate', function(ev) {
    dateShowLoader($element);
    if ($element.attr('data-no-redirect') === undefined) {
      const url = location.origin + location.pathname + '?date=' + dayjs(ev.date).format('YYYY-MM-DD');
      if ($element.parents('turbo-frame')[0]) {
        $element.parents('turbo-frame')[0].src = url;
      } else {
        Turbo.visit(url);
      }
    }
  });
});

document.arrive('.date_picker_wrapper [data-provide="datepicker"]', async function(element) {
  const $element = await initDatePicker(element);
  $element.on('changeDate', function() {
    if ('addChangeEvent' in this.dataset && this.dataset.addChangeEvent === 'true') {
      // trigger change event when date is changed
      const event = new Event('change');
      this.dispatchEvent(event);
    }
  });
});

document.arrive('.date_picker_wrapper [data-provide="monthpicker"]', async function(element) {
  await datetimepickerAssetsReady;
  const $element = $(element);
  // Month/year variant of the day picker: open on the month grid (minView 3) and format as mm/yyyy.
  $element.datetimepicker(withDatetimepickerLocale({
    format: 'mm/yyyy',
    autoclose: true,
    todayHighlight: true,
    minView: 3,
    maxView: 4,
    startView: 3,
    pickerPosition: $element.data().position ? $element.data().position : 'bottom-right',
  }));
  $element.on('changeDate', function() {
    if ('addChangeEvent' in this.dataset && this.dataset.addChangeEvent === 'true') {
      const event = new Event('change');
      this.dispatchEvent(event);
    }
  });
});

document.arrive('.date_picker_wrapper [data-provide="datetimepicker"]', async function(element) {
  await datetimepickerAssetsReady;
  const $element = $(element);
  $element.datetimepicker(withDatetimepickerLocale({
    format: $element.data().format,
    autoclose: true,
    todayHighlight: true,
    minView: 0,
    maxView: 2,
    minuteStep: $element.data()['minute-step'],
    pickerPosition: $element.data().position ? $element.data().position : 'bottom-right',
  }));
});

document.arrive('.date_picker_wrapper [data-provide="yearfirstdatepicker"]', async function(element) {
  await datetimepickerAssetsReady;
  const $element = $(element);
  $element.datetimepicker(withDatetimepickerLocale({
    startView: 'decade',
    format: 'dd/mm/yyyy',
    todayHighlight: false,
    autoclose: true,
    todayBtn: false,
    minView: 2,
    maxView: 3,
    pickerPosition: $element.data().position ? $element.data().position : 'bottom-right',
  }));
  $element.on('changeDate', function(e) {
    // trigger change event when date is changed
    const event = new Event('change');
    this.dispatchEvent(event);
  });
  $element.data('datetimepicker').picker.attr('id', 'datetimepicker_' + $element.attr('id'));
});

document.arrive('.date_picker_wrapper .remove_input_date_picker', function(element) {
  const $element = $(element);
  $element.on('click', function() {
    const input = $(this).parents('.date_picker_wrapper').find('input');
    input.val('');
    input.trigger('changeDate');
  });
});

document.arrive('.date_picker_wrapper .calendar-icon', function(element) {
  const $element = $(element);
  $element.on('click', function() {
    $(this).parents('.date_picker_wrapper').find('input').click();
  });
});
